<template>
  <div
    :id="`ss-f-${slug}`"
    class="ss-fld"
    :class="{ 'is-changed': isChanged, 'is-bad': error, 'is-warn': warning }"
    :data-path="path"
  >
    <label v-if="label" class="ss-lbl" :for="`ss-i-${slug}`">{{ label }}</label>
    <span class="ss-time">
      <v-icon size="16" class="ss-time__ic">mdi-clock-outline</v-icon>
      <select
        :id="`ss-i-${slug}`"
        :aria-label="`${name} (${$t('settings_shell.hour')})`"
        :aria-invalid="error ? 'true' : null"
        @change="setHour($event.target.value)"
        @blur="touch"
      >
        <option value="" :selected="hour === ''">--</option>
        <option v-for="h in hours" :key="h" :value="h" :selected="h === hour">{{ h }}</option>
      </select>
      <b aria-hidden="true">:</b>
      <select
        :id="`ss-i-${slug}-m`"
        :aria-label="`${name} (${$t('settings_shell.minute')})`"
        :disabled="hour === ''"
        @change="setMinute($event.target.value)"
        @blur="touch"
      >
        <option v-if="hour === ''" value="" selected>--</option>
        <template v-else>
          <option v-for="m in minutes" :key="m" :value="m" :selected="m === minute">{{ m }}</option>
        </template>
      </select>
    </span>
    <span v-if="error" :id="`ss-m-${slug}`" class="ui-err" role="alert">{{ error }}</span>
    <span v-else-if="warning" class="ui-warn">{{ warning }}</span>
  </div>
</template>

<script>
import hasSettingsField from "./hasSettingsField";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const STEP_MINUTES = ["00", "15", "30", "45"];

/** Vrijeme kao dva izbora (sat, minuta u koraku od 15); vrijednost je "HH:MM" ili prazno. */
export default {
  name: "SetTime",
  mixins: [hasSettingsField],
  props: {
    label: { type: String, default: "" },
    aria: { type: String, default: "" },
  },
  data: () => ({ hours: HOURS }),
  computed: {
    name() {
      return this.aria || this.label;
    },
    parts() {
      const [hour = "", minute = ""] = String(this.value || "").split(":");
      return { hour, minute };
    },
    hour() {
      return this.parts.hour;
    },
    minute() {
      return this.parts.minute;
    },
    /** Stara vrijednost koja nije u koraku od 15 (npr. 10:10) ostaje izbor dok je korisnik ne promijeni. */
    minutes() {
      const list = STEP_MINUTES.slice();
      if (this.minute && !list.includes(this.minute)) {
        list.push(this.minute);
        list.sort();
      }
      return list;
    },
  },
  methods: {
    setHour(hour) {
      this.write(hour === "" ? "" : `${hour}:${this.minute || "00"}`);
    },
    setMinute(minute) {
      this.write(this.hour === "" ? "" : `${this.hour}:${minute || "00"}`);
    },
  },
};
</script>
